import { supportedLanguages } from 'izumi/supportedLanguages'
import { userConfig } from 'lib/config'
import { getLanguageCode } from 'utils/izumi'

import data from '../data.json'

interface FaqLocalizedLink {
  terms: string
  privacy: string
  cookie: string
}
export const getFaqLocalizedLink = (): FaqLocalizedLink => {
  const locale = getLanguageCode(
    navigator.language,
    [...supportedLanguages, 'fr-CA', 'ko-KR', 'ar-EG', 'ar-BH', 'uk-UA', 'sr'],
    userConfig.language
  )

  if (data[locale as keyof typeof data] !== undefined) {
    return data[locale as keyof typeof data]
  }

  return data['en-US']
}
